// extracted by mini-css-extract-plugin
export default {"container":"common_container__RdQWc","desc":"common_desc__nXvGJ"};